var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconresearchDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H8.00003V18H22V2.00002C22 0.895453 21.1046 0 20 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00003 0C3.34319 0 2.00003 1.34316 2.00003 3V18.765C2.54917 18.2715 3.26172 17.999 4.00005 18H6.00001V0H5.00003Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24H3.99995C2.89539 24 1.99994 23.1046 1.99994 22C1.99994 20.8954 2.89539 19.9999 3.99995 19.9999H22V24Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconresearchDark);
export default __webpack_public_path__ + "static/media/icon=research-dark.85007f3ea6a9b80cc02884e627a61041.svg";
export { ForwardRef as ReactComponent };